import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=abc77884&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abc77884')) {
      api.createRecord('abc77884', component.options)
    } else {
      api.reload('abc77884', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=abc77884&", function () {
      api.rerender('abc77884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-83M8h9S4UjSHY/JS/stardisplay.vue"
export default component.exports